import React, { Component } from "react";
import { ThemeProvider } from "styled-components";
import { Provider } from "react-redux";
import { MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import { theme, muiTheme } from "./theme.js";
import store from "./../config/store.js";
import MainRouter from "./MainRouter";

class App extends Component {
  componentDidMount() {
    const storage_key = 'sso_referrer';
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      try {
        const sso_referrer = localStorage.getItem(storage_key);
        if (sso_referrer) {
          //remove item regardless of its contents
          localStorage.removeItem(storage_key);
          //value matches format /summary-reports/{guid} like
          if (/^\/summary-reports\/[0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12}/g.test(sso_referrer)) {
            window.location = sso_referrer;
          }

        }
      }catch (ex){
        console.log(ex);
      }
    }
  }  

  render() {
    return (
      <Provider store={store}>
        {/* https://material-ui.com/guides/interoperability/#controlling-priority-3 */}
        <StylesProvider injectFirst>
          <ThemeProvider theme={theme}>
            <MuiThemeProvider theme={muiTheme}>
              <MainRouter />
            </MuiThemeProvider>
          </ThemeProvider>
        </StylesProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/modules/App.js